export default __webpack_public_path__ + "static/media/001-ambulance.162c9b55.svg";